import helpers from "../utils/helpers";

const ContactUs = {
  init() {
    this.events();
  },
  events() {
    $("#contact-form").on("submit", (e) => {
      e.preventDefault();
      ContactUs.validate();
    });
    $("#agrChecked").on("click", function () {
      $(".form-status").html("").addClass("hidden");
    });
  },

  validate() {
    const formEl = $("#contact-form");

    formEl.addClass("loading");

    $(".error", this).removeClass("error");

    if (helpers.validate(formEl)) {
      setTimeout(() => {
        ContactUs.recaptcha();
      }, 500);
    } else {
      formEl.removeClass("loading");
      const erInp = formEl.find(".error");
      erInp.toArray().forEach((input) => {
        $(input).parent().parent().addClass("row-w-error");
      });
    }
  },

  recaptcha() {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        ContactUs.submit(token);
      });
    });
  },

  submit(token) {
    const formEl = $("#contact-form");

    const formData = new FormData(formEl[0]);

    // formData.append("file", $('input[type=file]')[0].files[0]);

    formData.append("token", token);

    formEl.find("button").addClass("loading");
    formEl.find(".form-status").addClass("hidden");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          formEl[0].reset();
          $("#fileLabel").text("");
          $(".drop-lable").css({ display: "flex" });
          formEl.find(".errors-wrap").remove();
          formEl.find(".form-status").removeClass("error");
        } else {
          formEl.find(".form-status").addClass("error");
        }

        formEl
          .find(".form-status")
          .text(response.data.message)
          .removeClass("hidden");
      })
      .always(() => {
        formEl.removeClass("loading");
        formEl.find("button").removeClass("loading");
      });
  },
};

export default ContactUs;
